import { Copy, Lock, Check } from "lucide-react";
import { useState } from "react";
import { toast } from "sonner";

export default function IdentityLock({ text }) {
  const [copied, setCopied] = useState(false);
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(text);
    } catch {
      const ta = document.createElement("textarea");
      ta.value = text; document.body.appendChild(ta); ta.select(); document.execCommand("copy"); ta.remove();
    }
    setCopied(true); toast.success("Identity Lock copied");
    setTimeout(() => setCopied(false), 1800);
  };
  return (
    <section className="panel p-6 md:p-8 relative overflow-hidden border-[#9C4DDC]/50" data-testid="identity-lock-panel">
      <div className="absolute -top-24 -right-24 w-56 h-56 rounded-full bg-[#9C4DDC]/10 blur-3xl pointer-events-none" />
      <div className="flex items-start justify-between gap-4 mb-4">
        <div>
          <p className="eyebrow flex items-center gap-2"><Lock size={12} /> Identity Lock</p>
          <p className="muted text-xs mt-2">This paragraph is added to every prompt so she always looks the same.</p>
        </div>
        <button className="btn-primary py-2 px-4 shrink-0" onClick={copy} data-testid="identity-lock-copy-button">
          {copied ? <Check size={14} /> : <Copy size={14} />} {copied ? "Copied" : "Copy"}
        </button>
      </div>
      <p className="quote text-[15px] md:text-base leading-relaxed select-all" data-testid="identity-lock-text">{text}</p>
    </section>
  );
}
